<template>
    <div class="app-inner" id="SolutionClass">
         <div class="public-btn-div flex align-cen">
      <div class="public-add"  @click="addBus">
        新增分类
      </div>
           <div class="businessList_header flex align-cen mft">
            <el-input
            placeholder="请输入分类名称"
            v-model="searchname"
            clearable
            >
            <i slot="prefix" class="el-input__icon el-icon-search" @click="search"></i>
        </el-input>
          <el-select
            v-model="value1"
            clearable
            placeholder="全部"
            class="flex"
            @change="classSelect1"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
         <div class="businessList-filter-list flex align-cen public-btn-small" style="padding-left:0">
            <div class="public-btn-small-primary" @click="search">
          搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
     </div>
    </div>
      <div class="businessList-container">
        <div class="businessList-container-table">
                        <el-table
            :data="itemList"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
            <el-table-column
            prop="name"
            label="分类"
           align="center"
             >
             <template slot-scope="scope" >
               <div v-if="scope.row.sort == 0">
                    <p style="color:#000">{{scope.row.name}}</p>
                    <p style="font-size:13px"> {{scope.row.remark}}</p>
               </div>
                <div v-else style="color:#000">
                {{scope.row.name}}
               </div>
              </template>
            </el-table-column>
            <el-table-column label="应用官网分类" align="center" >
          <template slot-scope="scope">
            <span>
              {{$util.offType(scope.row.officialType)}}
            </span>
          </template>
         </el-table-column>
            <el-table-column
            prop="sort"
            label="排序"
           align="center"
            >
            </el-table-column>
            <el-table-column
            label="操作"
            align="center"
            >
              <template slot-scope="scope">
                <div  v-if="scope.row.sort != 0">
                    <el-button type="text" size="small" @click.stop="editPro(scope.row)">编辑</el-button>
                <el-button type="text" size="small" @click.stop="deletPro(scope.row)" class="daner">删除</el-button>
                </div>
                <div v-else>
                  <el-button type="text" size="small"  style="color:red">禁止操作</el-button>  
                </div>
              </template>
            </el-table-column>
        </el-table>
         <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
        </div>
      </div>
           <!-- 增加修改弹窗 -->
      <el-dialog
  :title="tit"
  :visible.sync="centerDialogVisible"
  width="30%"
  :append-to-body="true"
  center>
   <div class="forminfo"
    v-loading="loading"
      element-loading-text="正在添加中..."
     element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
   >
    <el-form :model="formLabelAlign" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
         <el-form-item label="分类名称：" prop="name">
              <el-input v-model="formLabelAlign.name" clearable placeholder="20字以内" class="bbb"></el-input>
        </el-form-item>
         <el-form-item label="应用官网分类：" prop="officialType">
         <el-checkbox-group v-model="checkList" @change="classSelect">
            <el-checkbox label="1">和隆优化官网</el-checkbox>
            <el-checkbox label="2">和隆软件官网</el-checkbox>
        </el-checkbox-group>
         </el-form-item>
         <el-form-item label="排序：">
              <el-input v-model.number="formLabelAlign.sort" clearable class="bbb" minlength="0" maxlength="5"></el-input>
        </el-form-item>
    </el-form>
     <div class="btn" @click="onsubmit('ruleForm')">确定</div>
   </div>
</el-dialog>
    </div>
</template>
<script>
import {getJobClassify,deletJobList,getJobedit} from "@/api/index/index"  //岗位分类、删除岗位分类、新增修改
import debounce from '../../../utils/debounce.js' //防抖
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    name:'SolutionClass',
     components:{
      paginaTion
    },
    data() {
        return {
            checkList:[],
            value1:'',
             options:[
                {
                    id:'1',
                    name:'和隆优化官网'
                },
                {
                   id:'2',
                   name:'和隆软件官网' 
                }
            ],
            searchname:'',
            loading:false,
            edittype:0,
            tit:'',
            centerDialogVisible:false,
            totalNum:0,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount: 0,
            pageSizes:[10,20,30,40,50,100],
            itemList:[],
             formLabelAlign:{
            name:'',
            sort:'',
            id:'',
            officialType:''
        },
        rules: {
             name: [
             { required: true, message: '请正确填写分类名称', trigger: 'blur' },
             { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
          ],
           officialType:[{ required: true, message: '请选择应用官网分类', trigger: 'blur' }]
        }
        }
    },
    activated() {
        this.gethisInfo()
    },
    created () {
        
    },
    methods: {
       classSelect(){
           this.formLabelAlign.officialType = this.checkList.join(',')
        },
       classSelect1(){
        this.currentPage=1
            this.gethisInfo()
        },
         emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisInfo()
      },
        // 搜索
        search(){
        this.currentPage=1
        this.gethisInfo()
        },
        // 重置
        reset(){
           this.value1 = ""
            this.searchname = ""
            this.currentPage = 1
            this.gethisInfo()
        },
             // 确定
        onsubmit(formName){
            this.$refs[formName].validate((valid) => {
                if(valid){
                  if(typeof(this.formLabelAlign.sort) == 'string' && this.formLabelAlign.sort != "") return this.$util.Notifi('排序只能输入数字','error','fa-exclamation-circle')
                      //防抖提交
                            debounce(() => {
                             this.comHttps()
                         }, 500)
                }
            })
        },
                comHttps(){
          this.loading = true
          if(this.edittype == 0){
                        getJobedit(
                            {
                                name:this.formLabelAlign.name,
                                sort:this.formLabelAlign.sort,
                                officialType:this.formLabelAlign.officialType
                            },
                            'post')
                        .then(res => {
                           this.loading = false
                          if(res.code == 1){
                           this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
                          }else{
                           this.$util.Notifi('添加成功','success','fa-check')
                           this.gethisInfo()
                           setTimeout(() => {
                      this.centerDialogVisible = false
                    }, 100);
                          }
                        })
                        .catch(err => {
                          this.loading = false
                        })
                    }else{
                            getJobedit(
                            {
                                name:this.formLabelAlign.name,
                                sort:this.formLabelAlign.sort,
                                id:this.formLabelAlign.id,
                                officialType:this.formLabelAlign.officialType
                            },
                            'put')
                        .then(res => {
                          this.loading = false
                          if(res.code == 1){
                          this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
                          }else{
                            this.$util.Notifi('修改成功','success','fa-check')
                           this.gethisInfo()
                           setTimeout(() => {
                      this.centerDialogVisible = false
                       }, 100);
                          }
                        })
                        .catch(err => {
                          this.loading = false
                        })
                    }
        },
        // 新增
          addBus(){
           this.edittype = 0  //0表示新增项目，1表示修改项目
           this.tit = "新增岗位分类"
           this.centerDialogVisible = true 
           this.formLabelAlign = {
            name:'',
            sort:'',
            officialType:'',
           }
           this.checkList = []
           if(this.$refs['ruleForm']){
           this.$refs['ruleForm'].clearValidate();
         }
        },
           // 修改分类
        editPro(data){
            this.edittype = 1  //0表示新增项目，1表示修改项目
           this.tit = "修改岗位分类"
           this.centerDialogVisible = true 
           this.formLabelAlign = {
            name:data.name,
            sort:data.sort,
            id:data.id,
            officialType:data.officialType,
           }
            this.checkList = data.officialType.split(",")
               if(this.$refs['ruleForm']){
           this.$refs['ruleForm'].clearValidate();
         }
        },
        // 删除
        deletPro(data){
         this.$confirm('确定要删除该分类？删除后原该分类下的内容将变为“未分类”状态', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            deletJobList({
              id:data.id,
              },'delete')
                .then(res => {
                if(res.code == 1) return this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
                 if(res.code == 0){
                   this.$util.Notifi('删除成功','success','fa-check')
                   this.gethisInfo()
                 }
              })
              .catch(err => {
              })
        })
        },
         // 获取分类
        gethisInfo(){
            getJobClassify({
                name:this.searchname,
                current: this.currentPage,
                size:this.PageSize,
                officialType:this.value1
            })
            .then(res => {
              this.itemList = res.data.records
              this.totalCount = res.data.total;
            })
            .catch(err => {
            })
        },
    },
}
</script>
<style lang="scss" scoped>
#SolutionClass{
    padding: 0 20px;
    .businessList_header{
    .el-input{
        width: 200px;
        margin-right: 16px;
        height: 30px;
    }
}
}
.forminfo{
     .btn{
    width: 80%;
    height: 50px;
    background-color: #409eff;
    border-radius: 0.1vh;
    border: none;
    color: #fff;
    margin: 20px auto;
    margin-bottom: 0;;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
     }
}
::v-deep{
             .el-input__inner{
            height: 30px !important;
            line-height: 30px !important;
        }
        .el-input__icon{
            line-height: 30px;
        }
}
</style>